const NAME = "CLASSIFICATION_APPLICANTS_TYPES";

export default NAME;
